module.exports = __webpack_public_path__ + "static/media/8-trygt.d7740885.mp3";